var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "conn-stats",
      attrs: { "data-grm-comp": "RoomCallConnectionState" },
    },
    [
      _c("div", { staticClass: "conn-summary" }, [
        _c("span", [_vm._v("total[" + _vm._s(_vm.summary.totalCnt) + "]")]),
        _c("span", [
          _vm._v(
            "up[" +
              _vm._s(_vm.summary.sendCnt) +
              "/" +
              _vm._s(_vm.summary.send) +
              "/" +
              _vm._s(_vm.summary.sendAvg) +
              "]"
          ),
        ]),
        _c("span", [
          _vm._v(
            "down[" +
              _vm._s(_vm.summary.receiveCnt) +
              "/" +
              _vm._s(_vm.summary.receive) +
              "/" +
              _vm._s(_vm.summary.receiveAvg) +
              "]"
          ),
        ]),
      ]),
      _vm.windowMode
        ? _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterText,
                  expression: "filterText",
                },
              ],
              staticStyle: { width: "300px", height: "20px" },
              attrs: { type: "text" },
              domProps: { value: _vm.filterText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.filterText = $event.target.value
                },
              },
            }),
            _c(
              "button",
              {
                staticStyle: { width: "20px", height: "20px" },
                on: {
                  click: function ($event) {
                    _vm.filterText = ""
                  },
                },
              },
              [_vm._v("X")]
            ),
          ])
        : _vm._e(),
      _vm._l(_vm.filterUsers, function (r) {
        return _c("div", { key: r.userId, staticClass: "conn-stats-user" }, [
          _c("p", [
            _c("span", [_c("b", [_vm._v("[" + _vm._s(r.nickname) + "]")])]),
            !!r.device ? _c("span", [_vm._v(_vm._s(r.device))]) : _vm._e(),
            !!r.version
              ? _c("span", [_vm._v(", " + _vm._s(r.version))])
              : _vm._e(),
          ]),
          _c("p", [
            _c("span", [_vm._v("ConnTime: " + _vm._s(r.connTime))]),
            _c("span", [
              _vm._v(", Codecs: " + _vm._s(Array.from(r.codecs).join(","))),
            ]),
          ]),
          _c("p", [
            _vm._v(" " + _vm._s(r.connectionType.transport) + ", L:"),
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.parseCandidateType(r.connectionType.local.candidateType)
                ),
              },
            }),
            _vm._v(
              _vm._s(
                "(" +
                  (r.connectionType.local.networkType &&
                  r.connectionType.local.networkType !== "unknown"
                    ? r.connectionType.local.networkType + ", "
                    : "") +
                  r.connectionType.local.ipAddress +
                  ":" +
                  r.connectionType.local.port +
                  ")"
              ) + ", R:"
            ),
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.parseCandidateType(r.connectionType.remote.candidateType)
                ),
              },
            }),
            _vm._v(
              _vm._s(
                "(" +
                  (r.networkType && r.networkType !== "unknown"
                    ? r.networkType + ", "
                    : "") +
                  r.connectionType.remote.ipAddress +
                  ":" +
                  r.connectionType.remote.port +
                  ")"
              ) + " "
            ),
          ]),
          _c("p", [
            _vm._v(
              " Data: " +
                _vm._s(r.totalPacket) +
                ", S:" +
                _vm._s(r.packetSent) +
                " (" +
                _vm._s(r.videoBytesSent) +
                "/" +
                _vm._s(r.audioBytesSent) +
                "), R:" +
                _vm._s(r.packetReceived) +
                " (" +
                _vm._s(r.videoBytesReceived) +
                "/" +
                _vm._s(r.audioBytesReceived) +
                ") "
            ),
          ]),
          _c("p", { domProps: { innerHTML: _vm._s(r.videoSizeInfo) } }),
          _c("p", [_vm._v("BW: " + _vm._s(r.bandwidthInfo))]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }